'use client';

/**
 * Gift Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { Gift, Award, TrendingUp, UserPlus } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.giftPlan.hero"
                imageSrc="/images/mlm-plans/gift_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.giftPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.giftPlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.giftPlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.giftPlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6', 'advantage7', 'advantage8', 'advantage9']}
                gridCols="3"
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.giftPlan.commissions"
                commissions={[
                    { icon: Gift, color: 'primary', titleKey: 'gift.title', descriptionKey: 'gift.description' },
                    { icon: Award, color: 'blue', titleKey: 'rankAchievement.title', descriptionKey: 'rankAchievement.description' },
                    { icon: TrendingUp, color: 'green', titleKey: 'matching.title', descriptionKey: 'matching.description' },
                    { icon: UserPlus, color: 'purple', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                ]}
                gridCols="4"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.giftPlan.whySoftware" />
        </div>
    );
}

